import * as React from 'react';
import {
  PhoneInput as UiPhoneInput,
  type PhoneInputHandle,
  type PhoneInputProps as UiPhoneInputProps,
  type PhoneInputValue,
} from '@chekinapp/ui';
import {useFetchLocations} from '../../../hooks/useFetchLocations';

type PhoneInputProps = Omit<UiPhoneInputProps, 'options'>;

const PhoneInput = React.forwardRef<PhoneInputHandle, PhoneInputProps>(
  function PhoneInput({loading, ...props}, ref) {
    const {phoneCodesAsOptions, isLoadingLocations} = useFetchLocations();

    return (
      <UiPhoneInput
        ref={ref}
        {...props}
        loading={loading || isLoadingLocations}
        options={phoneCodesAsOptions}
      />
    );
  },
);

export {PhoneInput};
export type {PhoneInputProps, PhoneInputValue, PhoneInputHandle};
export default PhoneInput;
